export const formFields = () => {
  return [
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '费用编号',
      prop: 'expenseNoLike',
      type: 'input',
    },
    {
      name: '费用生成日期从',
      prop: 'periodDateFrom',
      type: 'startDaterangePicker',
    },
    {
      name: '费用生成日期至',
      prop: 'periodDateUntil',
      type: 'endDaterangePicker',
    },
  ];
};

export const tableColumnList = [
  {
    field: 'expenseNo',
    title: '费用编号',
  },
  {
    field: 'createMethod',
    title: '创建方式',
  },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
  },
  {
    field: 'businessCategory',
    title: '业务类别',
  },
  {
    field: 'businessCompanyName',
    title: '公司名称',
  },
  {
    field: 'businessDepartmentName',
    title: '部门名称',
  },
  {
    field: 'customerName',
    title: '客户名称',
    width: '150',
  },
  {
    field: 'contractNo',
    title: '合同编号',
  },
  {
    field: 'accountPeriod',
    title: '应付账期',
    width: '150',
  },
  {
    field: 'expenseTypeName',
    title: '费用类型',
  },
  {
    field: 'originalPrice',
    title: '结算单价(含税)',
  },
  {
    field: 'statementQuantity',
    title: '结算数量',
  },
  {
    field: 'unitName',
    title: '计量单位',
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
  },
  {
    field: 'currencyName',
    title: '币种',
  },
  {
    field: 'exchangeRate',
    title: '汇率',
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额(含税)',
  },
  {
    field: 'periodDateFrom',
    title: '业务结算日期从',
  },
  {
    field: 'periodDateUntil',
    title: '业务结算日期至',
  },
  {
    field: 'processStatus',
    title: '状态',
  },
  {
    field: 'businessDocCode',
    title: '业务单据编码',
  },

  {
    field: 'settlementNo',
    title: '结算单编号',
  },
  {
    field: 'salesmanName',
    title: '业务员',
  },
  {
    field: 'goodsCategoryName',
    title: '货物品类',
  },
];
